export default "__VITE_ASSET__CkdRPjtw__"